import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { HomePage } from './pages/HomePage';
import { AdminLayout, DealsBlock } from './widgets/cms/ui';


declare global {
  interface Window {
    OfferChat: {
      init: (config: any) => void;
    }
  }
}

function App() {
  
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<DealsBlock />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
